import { environment } from '../../environments'
import promoApi from '../../api/promo-api'

const endpoint = environment.promoApi.endpoints.stores

export const getIdentificationInfoEffect = async () => {
  return await promoApi.get(endpoint.identificationInfo)
}
